var map = {
	"./menu0.png": "fc0c",
	"./menu1.png": "b41d",
	"./menu2.png": "c6e1",
	"./menu3.png": "7827",
	"./menu4.png": "6ef4",
	"./menu5.png": "8cce",
	"./menu6.png": "354e",
	"./menu7.png": "7076",
	"./menu8.png": "0664",
	"./menu9.png": "c72b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5892";